import React from 'react';
import logoBase64 from '../assets/zemedic-logo';

const ZemedicLogo = ({ className = 'h-8 w-auto' }) => {
  return (
    <img 
      src={require('../assets/images/zemedic-logo.png')} 
      alt="ZemedicAI Logo" 
      className={className}
    />
  );
};

export default ZemedicLogo;
